var _rect, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFssaiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 80",
    width: 200,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 80,
    rx: 8,
    fill: "#1a5276"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 30,
    textAnchor: "middle",
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "FOOD SAFETY AND")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 44,
    textAnchor: "middle",
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "STANDARDS AUTHORITY")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 58,
    textAnchor: "middle",
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "OF INDIA")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 72,
    textAnchor: "middle",
    fill: "#f1c40f",
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: "bold"
  }, "\u2605 fssai.gov.in \u2605")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFssaiLogo);
export default __webpack_public_path__ + "static/media/fssai-logo.81cd2fcccb5aa6c2024a2e2434dfa0cb.svg";
export { ForwardRef as ReactComponent };